import $ from 'jquery';

export default class AnswersList {
	constructor() {
		this.linkList = $('.answers-list__link-list');
	}

	init() {
		this.linkList.each(function () {
			const array = [];
			let sum = 0;
			for (let i = 0; i < 3; i++) {
				array[i] = $(this).find('.answers-list__item').eq(i).outerHeight(true);
				sum += array[i];
			}
			$(this).height(sum);
			const linkListLength = $(this).children().length;
			if (linkListLength <= 3) {
				$(this).parent().siblings('.answers__button').addClass('answers__button_hidden');
			}
		});
	}
}



// WEBPACK FOOTER //
// ./app/blocks/answers-list/index.js